import * as _ from 'lodash';
import { Form } from '../application/form';
import { AttributeDefinition } from '../attributes/attributeDefinition';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { SurveyStatus } from './surveyStatus';

export class SurveyForm {
  public form: Form;
  public questions: AttributeDefinition[];
  public status: SurveyStatus;
  public teamName: string;
  public publicTeamName: string;
  public attributes: Attribute[] = [];

  get title(): string {
    return this.form ? this.form.title : undefined;
  }

  get hasIntroduction(): boolean {
    return !_.isNil(this.introduction);
  }

  get introduction(): string {
    return this.form ? this.form.introduction : undefined;
  }

  get hasConfirmation(): boolean {
    return !_.isNil(this.confirmation);
  }

  get hasCompleted(): boolean {
    return this.status === SurveyStatus.Complete;
  }

  get confirmation(): string {
    return this.form ? this.form.confirmation : undefined;
  }

  public static parse(data: any): SurveyForm {
    if (!data) return null;
    let surveyForm = new SurveyForm();
    Object.assign(surveyForm, data);
    surveyForm.form = Form.parse(data.form);
    surveyForm.questions = _.map(data.questions, (question) => {
      let q = AttributeDefinition.parse(question);
      q.conditions = question.conditions;
      return q;
    });
    surveyForm.attributes = data.attributes
      ? data.attributes.map((att) => Attribute.parse(att))
      : [];
    return surveyForm;
  }
}
